import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Vaccination from './Component/Vaccination';

const getSelectedChild = (state) => state.child.childList && state.child.childList.length && state.child.childList[state.child.selectedChild || 0]

const mapStateToProps = (state, ownProps) => ({
    child: getSelectedChild(state),
    user: state.auth.userProfile,
    vaccines: state.metaData.vaccineList,

    isUpdating: state.child.updateChild.isUpdating,
    updateStatus: state.child.updateChild.status,
    updateError: state.child.updateChild.error
});


const mapDispatchToProps = (dispatch) => ({
    fetchVaccination: () => dispatch(Actions.fetchVaccination()),
    saveVaccination: (payload) => dispatch(Actions.updateUser(payload, {action: Actions.responseUpdateChildUser})),
    fetchChildList: (userId) => dispatch(Actions.fetchChildList({ userId }))
});


export default connect(mapStateToProps, mapDispatchToProps)(Vaccination)